"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyLink = exports.updateLinkToken = exports.updateInviteLinkInfo = exports.getLinkInviteList = exports.getSubTeamInvite = exports.updateLinkInviteList = exports.updateSubTeamTreeInvite = exports.updateTeamTreeInvite = exports.getMailLinkData = exports.updateMailToken = exports.updateInviteEmailInfo = exports.updateErrCode = void 0;
const actions = __importStar(require("../../../shared/store/action_constants"));
const api_1 = require("../../../../exports/api");
function updateErrCode(code) {
    return {
        type: actions.UPDATE_INVITE_ERR_CODE,
        payload: code,
    };
}
exports.updateErrCode = updateErrCode;
/**
 * invite by email
 * @param info
 * @returns
 */
function updateInviteEmailInfo(info) {
    return {
        type: actions.UPDATE_INVITE_EMAIL_INFO,
        payload: info,
    };
}
exports.updateInviteEmailInfo = updateInviteEmailInfo;
const updateMailToken = (token) => {
    return {
        type: actions.UPDATE_MAIL_TOKEN,
        payload: token,
    };
};
exports.updateMailToken = updateMailToken;
const getMailLinkData = (token) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield api_1.Api.inviteEmailVerify(token);
        dispatch(updateInviteEmailInfo(data));
        if (!data.success) {
            dispatch(updateErrCode(data.code));
        }
    });
};
exports.getMailLinkData = getMailLinkData;
/**
 * invite by link - inviter
 * @param childrenTree
 * @returns
 */
const updateTeamTreeInvite = (childrenTree) => {
    return {
        type: actions.UPDATE_TEAM_TREE_INVITE,
        payload: childrenTree,
    };
};
exports.updateTeamTreeInvite = updateTeamTreeInvite;
const updateSubTeamTreeInvite = (parentId, childrenTree) => {
    return {
        type: actions.UPDATE_SUB_TEAM_TREE_INVITE,
        payload: { parentId, childrenTree },
    };
};
exports.updateSubTeamTreeInvite = updateSubTeamTreeInvite;
const updateLinkInviteList = (list) => {
    return {
        type: actions.UPDATE_LINK_LIST,
        payload: list,
    };
};
exports.updateLinkInviteList = updateLinkInviteList;
const getSubTeamInvite = (teamId) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        const subTree = yield api_1.Api.getSubTeams(teamId);
        dispatch((0, exports.updateSubTeamTreeInvite)(teamId, subTree.data.data));
    });
};
exports.getSubTeamInvite = getSubTeamInvite;
// TODO: to be delete by yudongdong
const getLinkInviteList = () => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        const { data: { success, data } } = yield api_1.Api.getLinkList();
        if (success) {
            dispatch((0, exports.updateLinkInviteList)(data));
        }
    });
};
exports.getLinkInviteList = getLinkInviteList;
/**
 * invite by link - invitee(be invited)
 * @param data
 * @returns
 */
const updateInviteLinkInfo = (data) => {
    return {
        type: actions.UPDATE_INVITE_LINK_INFO,
        payload: data,
    };
};
exports.updateInviteLinkInfo = updateInviteLinkInfo;
const updateLinkToken = (token) => {
    return {
        type: actions.UPDATE_LINK_TOKEN,
        payload: token,
    };
};
exports.updateLinkToken = updateLinkToken;
const verifyLink = (token) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        const { data } = yield api_1.Api.linkValid(token);
        dispatch((0, exports.updateInviteLinkInfo)(data));
    });
};
exports.verifyLink = verifyLink;
//# sourceMappingURL=invite.js.map